var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 3H8.47782C9.93586 3 11.1828 4.04832 11.4332 5.4847L13.2667 16V16C12.4605 15.1015 11.3104 14.5882 10.1033 14.5882H4.28758L5 21L3 3ZM11.3946 5.08924L13.1675 15.2789C13.4175 16.7158 14.6647 17.7647 16.1231 17.7647H22L19.75 12L21 6.17647H13.2444C12.4762 6.17647 11.7683 5.76039 11.3946 5.08924V5.08924Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.4c53df7ed0a45711bddb0cdfb4f1f112.svg";
export { ForwardRef as ReactComponent };